module.exports = __webpack_public_path__ + "static/media/hero-chat.b5dfc9ad.png";